import React from 'react'
// import Select from 'react-select/async'

import useViewModel from './ViewModel'
import moment from 'moment'
import 'moment-timezone'
import 'moment/locale/th'

const PanelView: React.FC = () => {
  const {
    // hasPatient,
    isShowWaiting,
    isSubmitting,
    info,
    patientNameText,
    setPatientNameText,
    // searchPatientPromiseOptions,
    // setSelectedSearchPatientId,
    // onSubmitSearchPatient,
    onSubmitPatientName
  } = useViewModel()

  console.log('info', info)

  return (
    <React.Fragment>
      <div className='min-h-screen p-8 bg-slate-300'>
        {isShowWaiting && (
          <div className={'flex flex-col gap-10 flex-grow'}>
            <div
              className='bg-white rounded-lg px-10 py-5 flex flex-col justify-center items-center h-full'
              style={{ height: '90vh' }}
            >
              <div className='text-center font-bold text-4xl'>
                กรุณารอสักครู่
              </div>
            </div>
          </div>
        )}

        {Object.keys(info).length > 0 && (
          <React.Fragment>
            <div className={'flex flex-col gap-10 flex-grow'}>
              <div
                className='bg-white rounded-lg shadow-lg px-10 py-5 flex flex-col justify-between'
                style={{ minHeight: '30vh' }}
              >
                <div className='text-center text-orange-400 font-bold text-2xl'>
                  คิวของฉัน
                </div>
                <h1 className='text-center text-gray-600 font-extrabold text-5xl'>
                  {info?.queue?.currentQueueNumber ?? 0}
                </h1>
                <span className='text-center text-lg font-semibold'>
                  <div className='text-gray-400 '>เช็คอินเมื่อ</div>

                  <div className='text-gray-700'>
                    {moment(info?.queue?.checkinAt)
                      .tz('Asia/Bangkok')
                      .locale('th')
                      .add(543, 'year')
                      .format('DD MMMM YYYY HH:mm')}
                  </div>
                </span>
              </div>

              {/* {hasPatient && (
                <React.Fragment>
                  <div
                    className='bg-white rounded-lg shadow-lg px-4 py-5 flex flex-col'
                    style={{ minHeight: '25vh', gap: '12px' }}
                  >
                    <div className='text-gray-800 text-lg text-center font-semibold'>
                      ข้อมูลคนไข้ที่รอ
                    </div>

                    <div className='text-gray-800 text-center'>
                      {`${info?.queue?.patient?.firstName ?? ''} ${
                        info?.queue?.patient?.lastName ?? ''
                      }`}
                    </div>
                    <div className='text-gray-700 text-center'>
                      {info?.queue?.patient?.hn
                        ? `เลขที่ระเบียน: ${info?.queue?.patient?.hn}`
                        : ''}
                    </div>
                    <div className='text-gray-500 text-center text-sm'>
                      (หากมีคำถามหรือข้อสงสัยในการเข้ารับบริการ
                      โปรดติดต่อที่หน้าเคาน์เตอร์)
                    </div>
                  </div>
                </React.Fragment>
              )} */}

              {info?.queue?.patientName && (
                <React.Fragment>
                  <div
                    className='bg-white rounded-lg shadow-lg px-4 py-5 flex flex-col'
                    style={{ minHeight: '25vh', gap: '12px' }}
                  >
                    <div className='text-gray-800 text-lg text-center font-semibold'>
                      ชื่อ-นามสกุล ของคุณ
                    </div>

                    <div className='text-gray-800 text-center'>
                      {`${info?.queue?.patientName ?? ''}`}
                    </div>
                    <div className='text-gray-500 text-center text-sm'>
                      (หากมีคำถามหรือข้อสงสัยในการเข้ารับบริการ
                      <br />
                      โปรดติดต่อที่หน้าเคาน์เตอร์)
                    </div>
                  </div>
                </React.Fragment>
              )}

              {/* {!hasPatient && (
                <React.Fragment>
                  <div
                    className='bg-white rounded-lg shadow-lg px-4 py-5 flex flex-col'
                    style={{ minHeight: '25vh', gap: '12px' }}
                  >
                    <div className='text-gray-800 text-center'>
                      หากคุณเคยเข้ารับการรักษาแล้ว
                      สามารถระบุชื่อของคุณหรือเลขที่บัตรประจำตัวบัตรประชาชน
                      เพื่อช่วยการเข้ารักษารวดเร็วขึ้น
                    </div>

                    <Select
                      cacheOptions
                      defaultOptions
                      loadOptions={searchPatientPromiseOptions}
                      onChange={selectedOption => {
                        if (selectedOption?.value)
                          setSelectedSearchPatientId(selectedOption?.value)
                      }}
                      placeholder='ระบุชื่อหรือนามสกุล'
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null
                      }}
                    />
                   

                    <button
                      type='button'
                      className='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center disabled:bg-blue-300'
                      // disabled={!canSubmitSearchPatient}
                      onClick={onSubmitSearchPatient}
                    >
                      ยืนยันข้อมูลคนไข้
                    </button>
                  </div>
                </React.Fragment>
              )} */}

              {!info?.queue?.patientName && (
                <React.Fragment>
                  <div
                    className='bg-white rounded-lg shadow-lg px-4 py-5 flex flex-col'
                    style={{ minHeight: '25vh', gap: '12px' }}
                  >
                    <div className='text-gray-800 text-center'>
                      กรุณาระบุชื่อ-นามสกุลของคุณ
                      <br />
                      เพื่อช่วยการเข้ารักษารวดเร็วขึ้น
                    </div>

                    <input
                      type='text'
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 '
                      placeholder='ระบุชื่อหรือนามสกุล'
                      value={patientNameText}
                      onChange={e => setPatientNameText(e.target.value)}
                    />

                    <button
                      type='button'
                      className={`text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center disabled:bg-blue-300`}
                      // disabled={!canSubmitSearchPatient}
                      disabled={isSubmitting}
                      onClick={onSubmitPatientName}
                    >
                      บันทึก
                    </button>
                  </div>
                </React.Fragment>
              )}

              <div
                className='bg-white rounded-lg shadow-lg px-10 py-5 flex flex-col justify-between'
                style={{ minHeight: '20vh' }}
              >
                <div className='text-center text-blue-400 text-lg'>
                  เหลืออีก
                </div>
                <div className='text-center text-blue-700 text-3xl'>
                  {info?.remaining ?? 0}
                </div>
                <div className='text-center text-gray-600 text-lg'>คิว</div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  )
}

export default PanelView
